export default __webpack_public_path__ + "static/media/Varied Pop 4.d6f79d10.mp3";